import React, { useState } from 'react'

// components
import {
  CAccordion,
  CAccordionHeader,
  CAccordionBody,
  CAccordionItem,
} from '@coreui/react-pro'
import AppFirstDetails from './AppFirstDetails'
import AppSecondDetails from './AppSecondDetails'

const AppDetails = ({
  couponDetails,
  couponImages,
}) => {

  return (
    <CAccordion activeItemKey={1}>
      <CAccordionItem itemKey={1}>
        <CAccordionHeader>
          <b>Basic Coupon Information</b>
        </CAccordionHeader>
        <CAccordionBody>
          <AppFirstDetails
            couponDetails={couponDetails}
            couponImages={couponImages}
          />
        </CAccordionBody>
      </CAccordionItem>
      <CAccordionItem itemKey={1}>
        <CAccordionHeader>
          <b>Coupon Eligibility</b>
        </CAccordionHeader>
        <CAccordionBody>
          <AppSecondDetails
            couponDetails={couponDetails}
          />
        </CAccordionBody>
      </CAccordionItem>
    </CAccordion>
  )
}

export default AppDetails
